// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__25_E6","tab":"Tabs_tab__3DZFy","tabActive":"Tabs_tabActive__NNRcU"};